<template>
  <router-view />
  <modal />
  <feature-flags-dialog />
  <ConfirmDialog />
</template>

<style lang="scss">
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #00586c;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
<script>
import { watch } from "vue";
import { Modal } from "./components/modal";
import { differenceInMinutes } from "date-fns";
import FeatureFlagsDialog from "./components/dialogs/FeatureFlagsDialog.vue";
import ConfirmDialog from "./components/ConfirmDialog.vue";
import { useFeatureFlags } from "./composables/useFeatureFlags";
import { useCountryConfig } from "./composables/useCountryConfig";

export default {
  name: "App",
  setup() {
    const { label } = useCountryConfig();
    // Keep the browser tab title in sync with the market: once a Norwegian
    // institution is detected the app name resolves to "Ressursplan". This
    // re-runs when the market (institution) or the locale changes.
    watch(
      () => label("appName"),
      (name) => {
        document.title = `${name} - IST`;
      },
      { immediate: true },
    );
  },
  data() {
    return {
      authenticated: false,
    };
  },
  components: {
    Modal,
    FeatureFlagsDialog,
    ConfirmDialog,
  },
  created() {
    // Remove userActivation from localStorage if it is older than 1 minute, to avoid getting stuck in useractivation mode.
    const userActivationObj = localStorage.getItem("userActivation")
      ? JSON.parse(localStorage.getItem("userActivation"))
      : undefined;
    if (
      userActivationObj &&
      differenceInMinutes(new Date(), new Date(userActivationObj.date)) > 1
    ) {
      localStorage.removeItem("userActivation");
    }
  },
  mounted() {
    // Add keyboard shortcut listener for Alt+Ctrl+F
    window.addEventListener("keydown", this.handleKeyboardShortcut);
  },
  beforeUnmount() {
    // Clean up event listener
    window.removeEventListener("keydown", this.handleKeyboardShortcut);
  },
  methods: {
    handleKeyboardShortcut(event) {
      // Check for Alt+Ctrl+F (also works with Cmd on Mac)
      if (event.altKey && event.ctrlKey && event.key.toLowerCase() === "f") {
        event.preventDefault();
        const { openDialog } = useFeatureFlags();
        openDialog();
      }
    },
  },
};
</script>
